import React, { useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "@material-ui/core/Slider";
import Loader from "../Loader/Loader";
import Logo from "../../assets/img/logo.png";
import { makeStyles } from "@material-ui/core/styles";
import HttpService from "../../HttpService";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles({
  root: {
    width: 300,
  },
});
const Header = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const [value, setValue] = React.useState([2000, 50000]);
  const [loading, setLoading] = React.useState(true);
  const [categories, setCategories] = React.useState([]);

  const [brand, setBrand] = useState(null);
  const [feature, setFeature] = useState(null);

  const handleSubmitSearchBar = async (event) => {
    let url = "/products/search";
    event.preventDefault();

    const values = {
      brand: brand,
      feature: feature,
      priceRange1: value[0],
      priceRange2: value[1],
    };

    try {
      setLoading(true);
      // const products = await HttpService.post(url, values);
      setLoading(false);
      history.push({
        pathname: "/products",
        state: {
          searchBar: values,
          // products: products.data.products,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categories = await HttpService.get("/categories");

        setCategories(categories.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCategories();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onPriceChange = (e, index) => {
    let priceArray = [];
    const price = e.currentTarget.value;
    priceArray = [...value];
    priceArray[index] = price;

    setValue(priceArray);
  };

  return (
    <React.Fragment>
      {/* <!-- =========================
  //     Header Top Section
  // ============================== --> */}
      <section id="main-slider-section" className="main-hero-section">
        <section
          id="wd-header"
          className="d-flex align-items-center mob-sticky d-lg-none"
        >
          <div className="container">
            <div className="row">
              {/* <!-- =========================
                    Mobile Menu 
                ============================== --> */}
              <div className="order-1 order-sm-1 col-4 col-sm-4 col-md-4 d-block d-lg-none">
                <div className="accordion-wrapper hide-sm-up">
                  <a href="#" className="mobile-open">
                    <i className="fa fa-bars"></i>
                  </a>
                  {/* <!--Mobile Menu start--> */}

                  <ul id="mobilemenu" className="accordion">
                    <li className="mob-logo">
                      <a href="/">
                        <img src={Logo} />
                      </a>
                    </li>
                    <li>
                      <a className="closeme" href="#">
                        <i className="fa fa-times"></i>
                      </a>
                    </li>

                    <li className="out-link">
                      <a className="" href="/">
                        Home
                      </a>
                    </li>
                    <li>
                      <a className="out-link" href="/products">
                        Mobile Phones
                      </a>
                    </li>
                    <li>
                      <a className="out-link" href="/packages">
                        Mobile Packages
                      </a>
                    </li>
                    <li className="out-link">
                      <a className="" href="/compareProducts">
                        Compare Phones
                      </a>
                    </li>
                    <li className="out-link">
                      <a className="" href="/comparePackages">
                        Compare Packages
                      </a>
                    </li>
                    {/* <li className="out-link">
                      <a className="" href="/contactUs">
                        Contact
                      </a>
                    </li> */}
                  </ul>
                  {/* <!--Mobile Menu end--> */}
                </div>
              </div>
              {/* <!--Mobile menu end--> */}

              <div className="order-1 order-sm-2  col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1 text-center">
                <div className="blrub-logo">
                  <a href="/">
                    <img src={Logo} />
                  </a>
                </div>
              </div>

              {/* <!-- =========================
                     Login and My Acount 
                ============================== --> */}
              <div className="order-3 order-sm-3 col-4 col-sm-4 col-md- col-lg-10 col-xl-10">
                {/* <!-- =========================
                         User Account Section
                    ============================== --> */}
                <div className="acc-header-wraper">
                  <div className="serch-wrapper">
                    <div className="search">
                      <input
                        className="search-input"
                        placeholder="Search"
                        type="text"
                      />
                      <a href="javascript:void(0)">
                        <i className="fa fa-search"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--Row End--> */}
          </div>
          {/* <!--Container End--> */}
        </section>
        {/* <!--Section End--> */}
        <section id="main-menu" className="sticker-nav">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-4 col-md-2 col-lg-2">
                <div className="blrub-logo">
                  <a href="/">
                    <img src={Logo} />
                  </a>
                </div>
              </div>
              <div className="col-2 col-md-6 col-lg-9">
                <div className="menu-container wd-megamenu">
                  <div className="menu">
                    <ul className="wd-megamenu-ul">
                      <li>
                        <a className="main-menu-list" href="/">
                          <i className="fa fa-home" aria-hidden="true"></i> Home
                        </a>
                      </li>
                      <li>
                        <a className="main-menu-list" href="/products">
                          Mobile Phone <i aria-hidden="true"></i>
                        </a>
                      </li>
                      <li>
                        <a className="main-menu-list" href="/packages">
                          Mobile Packages
                          <i aria-hidden="true"></i>
                        </a>
                      </li>
                      <li>
                        <Link className="main-menu-list">Compare</Link>
                        <ul className="single-dropdown">
                          <li>
                            <a href="/compareProducts">Compare Products</a>
                          </li>
                          <li>
                            <a href="/comparePackages">Compare Packages</a>
                          </li>
                        </ul>
                      </li>
                      {/* <li>
                        <a href="/contactUs" className="main-menu-list">
                          Contact
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-4 col-sm-4 col-md-8 col-lg-1 text-left">
                <div className="acc-header-wraper">
                  <div className="serch-wrapper">
                    <div className="search">
                      <input
                        className="search-input"
                        placeholder="Search"
                        type="text"
                      />
                      <a href="#">
                        <i className="fa fa-search"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col-md-12 pad-50-0">
              <h1 className="col-wit font-95 font-weight-700 text-center">
                FIND YOUR PHONE HERE
              </h1>
              <p className="col-grey text-xl-right font-30 font-weight-light text-center">
                and make communication better
              </p>
            </div>
          </div>
        </div>

        <Form onSubmit={(e) => handleSubmitSearchBar(e)}>
          <div className="container hero-price-sec">
            <div className="row">
              <div className="col-md-6">
                <div className="col-12">
                  <h3 className="font-weight-500 mar-bot-15">By Price</h3>
                </div>
                <div className="col-md-12">
                  <Slider
                    value={value}
                    min={2000}
                    max={200000}
                    color="primary"
                    thumbColor="secondary"
                    onChange={handleChange}
                    valueLabelDisplay="auto"
                    aria-labelledby="range-slider"
                  />
                </div>
                <div className="row pad-15" style={{ padding: 10 }}>
                  <div className="col-md-6 col-sm-7" style={{ padding: 10 }}>
                    <span className="font-weight-700">From Rs </span>
                    <input
                      type="text"
                      id="amount1"
                      name="range1"
                      value={value && value[0]}
                      onChange={(e) => onPriceChange(e, 0)}
                      // readOnly
                      style={{
                        border: 0,
                        color: "#f6931f",
                        fontWeight: "bold",
                      }}
                    />
                  </div>
                  <div
                    className="col-md-6 col-sm-7"
                    style={{ padding: 10, left: 10 }}
                  >
                    <span className="font-weight-700">to Rs </span>
                    <input
                      type="text"
                      id="amount1"
                      name="range1"
                      value={value && value[1]}
                      onChange={(e) => onPriceChange(e, 1)}
                      // readOnly
                      style={{
                        border: 0,
                        color: "#f6931f",
                        fontWeight: "bold",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6 verticle-line-bef">
                <div className="col-12" style={{ padding: 20 }}>
                  <h3 className="font-weight-500 mar-bot-15 p-0">Search By</h3>
                </div>
                <div className="row">
                  <div
                    className="col-md-4"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 10,
                    }}
                  >
                    <select
                      className=""
                      id="outlined-age-native-simple"
                      name="companies"
                      onChange={(e) => setBrand(e.currentTarget.value)}
                    >
                      <option aria-label="None" value="">
                        Brand
                      </option>
                      <option value="Nokia">Nokia</option>
                      <option value="Samsung">Samsung</option>
                      <option value="Xaomi">Xaomi</option>
                      <option value="Apple">Apple</option>
                      <option value="Oppo">Oppo</option>
                      <option value="Pixel">Pixel</option>
                      <option value="Panda">Panda</option>
                      <option value="Huawei">Huawei</option>
                      <option value="Motorola">Motorola</option>
                      <option value="Vivo">Vivo</option>
                    </select>
                  </div>
                  <div
                    className="col-md-4"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      left: 7,
                    }}
                  >
                    <select
                      className=""
                      id="outlined-age-native-simple"
                      name="categories"
                      onChange={(e) => setFeature(e.currentTarget.value)}
                    >
                      <option aria-label="None" value="">
                        Features
                      </option>

                      <option value="4g">4G</option>
                      <option value="camera">Camera</option>
                      <option value="budgetPhone">Budget Phone</option>
                      <option value="comingSoon">Coming Soon</option>
                      <option value="gaming">Gaming</option>
                      <option value="bigScreen">Big Screen</option>
                    </select>
                  </div>
                  <div className="col-md-4 text-center" style={{ top: 5 }}>
                    {!loading === false ? (
                      <Button
                        className="btn btn-secondary btn-sm"
                        type="submit"
                      >
                        Find My Phone
                      </Button>
                    ) : (
                      <Loader type="Circles" style={{ top: -20 }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </section>
    </React.Fragment>
  );
};

export default Header;
